import React, { useContext, useEffect, useRef } from "react";
import Modal from "@mui/material/Modal";
import utsavModalClasses from "../../src/globalModule/styles/utsavModal.module.css";
import { useRouter } from "next/router";
import { Store } from "@utils/store/ContextStore";
import { CONTACT_NUMBER } from "@utils/constants";

export default function BlockedUserModal({
  message,
  open,
  toggleModal,
  acceptMsg,
  rejectMsg,
}) {
  const router = useRouter();
  const { state } = useContext(Store);
  const loggedInUser = state.user;
  let [processing, setProcessing] = React.useState(false);
  const heading = "Account Restricted";

  const onAccept = async () => {
    let text = `Namaste Utsav Admin! \n\nThis is ${loggedInUser.name} from Utsav App. \n${process.env.NEXT_PUBLIC_APP_HOSTNAME}/profile/${loggedInUser.uid}/${loggedInUser.name} \n\nWhy has my account been restricted?`;
    let url = `https://api.whatsapp.com/send/?phone=91${CONTACT_NUMBER.number}&text=${text}`;
    router.push(url);
  };

  const ref = useRef();
  useEffect(() => {
    if (open) {
      window.addEventListener("keypress", acceptOnKey);
      return () => {
        window.removeEventListener("keypress", acceptOnKey);
      };
    }

    // eslint-disable-next-line
  }, [open]);

  useEffect(() => {
    if (open) {
      window.addEventListener("mousedown", onClickHandler);
      return () => {
        window.removeEventListener("mousedown", onClickHandler);
      };
    }
    // eslint-disable-next-line
  }, [open]);

  const acceptOnKey = (e) => {
    if (e.key === "Enter") {
      onAccept ? onAccept() : toggleModal();
    }
  };

  function onClickHandler(e) {
    if (ref.current && e.target) {
      const res = ref.current.contains(e.target);
      if (!res) toggleModal();
    }
  }

  return (
    <Modal open={open} onClose={toggleModal}>
      <div className={utsavModalClasses.modalOver}>
        <div ref={ref} className={utsavModalClasses.modalCard}>
          <div className={utsavModalClasses.modalCard__head}>
            {heading && (
              <h5 className={utsavModalClasses.modalCard__heading}>
                {heading}
              </h5>
            )}
            {message && (
              <div className={utsavModalClasses.modalCard__msg}>{message}</div>
            )}
          </div>
          <div className={utsavModalClasses.modalCard__options}>
            {acceptMsg && (
              <button
                className={`${utsavModalClasses.modalCard__btn} ${utsavModalClasses.modalCard__btn_pos}`}
                onClick={
                  onAccept
                    ? (e) => {
                        setProcessing((processing = true));
                        onAccept(setProcessing);
                        setTimeout(() => {
                          setProcessing(false);
                        }, 10000);
                      }
                    : toggleModal
                }
              >
                {processing ? (
                  <div className={utsavModalClasses.logoutWithLoader}>
                    <div
                      className={`${utsavModalClasses.loader}`}
                      id={`${utsavModalClasses.loader}`}
                    ></div>{" "}
                  </div>
                ) : (
                  acceptMsg
                )}
              </button>
            )}
            {rejectMsg && (
              <button
                className={`${utsavModalClasses.modalCard__btn} ${utsavModalClasses.modalCard__btn_neg}`}
                onClick={toggleModal}
              >
                {rejectMsg}
              </button>
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
}
